import { create } from 'zustand';

/**
 * Substrate panel — which right-edge slide-out (if any) is open.
 *
 * The substrate rail icons toggle a panel rather than navigate. Panel content
 * is the substrate concept's reference view + inline CRUD; full editor lives
 * at the route the panel exposes via "Open full →".
 *
 * Only one panel is open at a time. Re-clicking the same icon dismisses it.
 */
const useSubstratePanelStore = create((set, get) => ({
  activePanel: null,
  panelContext: null,
  peopleDrafts: {},
  peopleDirectories: {},
  peopleSaves: {},
  setPeopleSaving: (key, saving) => set((state) => ({ peopleSaves: { ...state.peopleSaves, [key]: saving } })),
  savePeopleDraft: (key, draft) => set((state) => ({ peopleDrafts: { ...state.peopleDrafts, [key]: draft } })),
  clearPeopleDraft: (key) => set((state) => {
    const drafts = { ...state.peopleDrafts };
    delete drafts[key];
    return { peopleDrafts: drafts };
  }),
  savePeopleDirectory: (key, directory) => set((state) => ({ peopleDirectories: { ...state.peopleDirectories, [key]: directory } })),

  openPanel: (key, context = null) => set({
    activePanel: key,
    panelContext: context,
  }),
  closePanel: () => set({ activePanel: null, panelContext: null }),
  togglePanel: (key, context = null) => {
    const current = get();
    const isSamePanel = current.activePanel === key;
    const isSameContext = context && current.panelContext
      && context.kind === current.panelContext.kind
      && context.view === current.panelContext.view;

    if (isSamePanel && (!context || isSameContext)) {
      set({ activePanel: null, panelContext: null });
      return;
    }
    set({ activePanel: key, panelContext: context });
  },
}));

export default useSubstratePanelStore;
